<template>
    <div>
        Need Help? Email
        <a href="mailto:sales@paragonintel.com" class="primary-link-light">sales@paragonintel.com</a>
        <span v-if="hasSalesContact"> or call {{ salesContact.name }} at {{ salesContact.phoneNumber }} </span>
    </div>
</template>
<script>
export default {
    computed: {
        configuration() {
            return this.$store.getters.customWork
        },
        hasSalesContact() {
            return this.configuration.hasSalesContact
        },
        salesContact() {
            return this.configuration.salesContact
        },
    },
}
</script>
